import { useEffect, useState } from "react";
import { Form, NavLink, Outlet, redirect } from "react-router-dom";
import { useAuthStore, User } from "src/components/main/authStore";
import { useMyStore } from "./mainStore";
import { myAxios, scroll } from "src/components/common/functions";
import appRoutes from "./AppRoutes";
import Profile from "../common/Profile";
import UserInfoModal from "../common/UserInfoModal";
import logoutimg from "src/img/logout.png";
import logo from "src/img/logo.png";
export default function MainLayout(){
    //--------------------------------------------------------------------------------------------
    const setMainMenuStyle = useMyStore(state => state.setMainMenuStyle);
    const mainMenuStyle = useMyStore(state => state.mainMenuStyle);
    const user = useAuthStore(state => state.user) as User;
    const [showUserInfo, setShowUserInfo] = useState(false);
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        const onResize = () => {
            if(window.innerWidth < 960){
                setMainMenuStyle(null);
            }
        }
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    },[setMainMenuStyle]);
    if(!user) return <></>;
    //---------------------------------------------------------------------------------------------------------------------
    return(
        <>
        <div className = "mainHeader" style = {{background: user.userTheme}}>
            <button type = "button" className = "text-nowrap noButtonStyle" onClick = {() => setShowUserInfo(true)}> 
                <Profile
                    value = {user.profileUrl!}
                    side = {50}
                />
                <span className = "me-2">{user.userName}</span><span className = "fw-bold">V{user.version}</span>
            </button>
            <div className = "greater700" style = {{alignItems: "center" ,display: "flex"}}> 
                <img src = {logo} style = {{height: "50px", display: "block"}} alt = ""/>
            </div>
            <Form method = "post">
                <button type = "submit" className = "text-nowrap noButtonStyle" style = {{background: "inherit", color: "inherit"}}>
                    <img src = {logoutimg} alt = "" className = "me-2"/>
                    <span className = "">Log out</span>
                </button>
            </Form>
        </div>
        <div className = "mainContent">
        <div className = "mainMenu" style = {mainMenuStyle ?? undefined}>
            <div style = {{background: user.userTheme}}>Menu</div>
            {appRoutes(user).map((value, index) => 
            value.show?
            <NavLink
                key = {index}
                to = {value.path.split("/")[0]} 
                style = {({ isActive }) => ({
                    backgroundColor: isActive ? "gray" : "",
                    color: isActive ? "white" : ""
                })}
                onClick = {() => scroll(null)}
            >
                <img src = {value.img} alt = ""/>
                {value.title}
            </NavLink>
            :null)}
        </div>
        <div className = "mainComp">
            <Outlet/>
        </div>
    </div>
        {showUserInfo?
            <UserInfoModal
                user = {user}
                closeIt = {() => setShowUserInfo(false)}
                actionKey = "Save"
                editTheme
                editPhoto
            />
        :null}
        </>
    )
}

export async function logOutAction(){
    const res = await myAxios({ fileName: "auth/end.php" });
    if (!res) return;
    throw redirect("/Login");
}

export async function authLoader(){
    const store = useAuthStore.getState();
    let auth = store.isAuthenticated;
    if(!store.isAuthChecked){
        const res = await myAxios({ fileName: "auth/refresh.php" }); // HydrateFallback will apear during this wait.
        store.setAuthChecked(true);
        if(!res){
            store.setAuthenticated(false);
            auth = false;
        }else{
            store.setAuthenticated(true);
            auth = true;
            store.setUserInfo(res.data);
        }
    }
    if(!auth){
        throw redirect('/Login');
    }else{
        return {};
    }
}
